import { Avatar } from "primereact/avatar";
import { Tooltip } from "primereact/tooltip";
import { useEffect, useRef, useState } from "react";

export const EllipsisTooltip = ({ text, maxWidth = 200 ,icon}) => {
    const textRef = useRef(null);
    const [isEllipsis, setIsEllipsis] = useState(false);
  
    useEffect(() => {
      if (textRef.current) {
        setIsEllipsis(textRef.current.scrollWidth > textRef.current.clientWidth);
      }
    }, [text]);
  
    return (
      <div style={{ padding: "10px", display: "flex", alignItems: "center", gap: "8px" }}>
      {isEllipsis && <Tooltip target=".ellipsis-text" />}

      {/* Icon on the Left */}
     {icon&& <Avatar icon={icon} shape="circle" />}

      <span
        ref={textRef}
        className="ellipsis-text"
        data-pr-tooltip={isEllipsis ? text : null} // Tooltip only if text is truncated
        style={{
          display: "inline-block",
          maxWidth: `${maxWidth}px`,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontSize:'12pt'
        }}
      >
        {text}
      </span>
    </div>
    );
  };